import * as React from 'react';
import * as _ from 'lodash';
import {
  ControlState,
  ControlStyleClass,
  ControlValidation,
  EmailConfiguration,
  Logging,
  renderEdit,
  validateEmail,
} from '@vcd-ecm-ui/Common';
import { VtxIcon, VtxTooltip } from '@vertexinc/vtx-ui-react-component-library';
import Step2Props from './Step2Props.interface';
import Footer from '../Footer/Footer';
import '../../../common-correspondence.scss';
import '../../configuration.scss';

const maxEmailLength = 100;

const styles: ControlStyleClass = null;

const state: ControlState = {
  editable: true,
  disabled: false,
  readOnly: false,
};

const validation: ControlValidation = {
  requiredFields: ['fromEmailAddress', 'errorEmailAddress'],
  emailFields: ['fromEmailAddress', 'errorEmailAddress'],
  minMaxSize: [
    { field: 'fromEmailAddress', maxSize: maxEmailLength },
    { field: 'errorEmailAddress', maxSize: maxEmailLength },
  ],
  customMessages: [],
};

const Step2 = ({
  gatewayEndPoint,
  configuration,
  onBack,
  onCancel,
  onNext,
}: Step2Props): JSX.Element => {
  // Extract the Email address from the Domain
  const extractEmail = (email: string): string => {
    if (email) {
      const offset = email.indexOf('@');

      if (offset >= 0) {
        return email.substring(0, offset);
      }
    }

    return email;
  };

  // Append the Domain to the Email
  const combineAddressAndDomain = (email: string): string => `${email}@${configuration.domain}`;

  const [fromEmailAddress, setFromEmailAddress] = React.useState(extractEmail(configuration?.fromEmailAddress));
  const [errorEmailAddress, setErrorEmailAddress] = React.useState(configuration?.errorEmailAddress);

  const saveConfiguration = (): void => {
    const copyConfiguration: EmailConfiguration = _.cloneDeep(configuration);
    copyConfiguration.fromEmailAddress = combineAddressAndDomain(fromEmailAddress); // Append the Domain
    copyConfiguration.errorEmailAddress = errorEmailAddress;

    onNext(copyConfiguration);
  };

  const validateStep = (): boolean => {
    if (!fromEmailAddress) {
      return false;
    }

    if (!errorEmailAddress) {
      return false;
    }

    if (!validateEmail(combineAddressAndDomain(fromEmailAddress))) {
      return false;
    }

    if (combineAddressAndDomain(fromEmailAddress).length > maxEmailLength) {
      return false;
    }

    if (!validateEmail(errorEmailAddress)) {
      return false;
    }

    if (errorEmailAddress && (errorEmailAddress.length > maxEmailLength)) {
      return false;
    }

    return true;
  };

  // eslint-disable-next-line arrow-body-style
  const infoTooltip = (tooltip: string) : JSX.Element => {
    return (
      <VtxTooltip title={tooltip}>
        <VtxIcon type="info-circle" fontSize={16} color="gray" className="infoTooltip" />
      </VtxTooltip>
    );
  };

  const backVisible = true;
  const backEnabled = true;
  const nextVisible = true;
  const cancelVisible = true;
  const cancelEnabled = true;
  const nextEnabled = validateStep();
  const fromEmailTooltip = 'The From Email Tooltip will go here.\r\nIt can be very long and consist of multiple lines.';
  const errorEmailTooltip = 'The Error Email Tooltip will go here.\r\nIt can be very long and consist of multiple lines.';

  return (
    <>
      <div className="stepContent">
        <div className="descriptionHeading">
          Address Service
        </div>
        <div className="descriptionText">
          By Default Your Emails Will Be Sent Using Vertex Addresses. Enter  Your Own Company Specific Address To Send and Receive Correspondence.
        </div>
        <br />
        <br />
        {renderEdit(66, 'fromEmailAddress', 'Enter The Send From Address', 'email', 'Example: certificates',
          fromEmailAddress, setFromEmailAddress, state, styles, validation, null, infoTooltip(fromEmailTooltip), null, combineAddressAndDomain(''))}
        <br />
        {renderEdit(66, 'errorEmailAddress', 'Enter the Master Address for Receiving Error Notifications', 'email', 'Example: errors@vertex.com',
          errorEmailAddress, setErrorEmailAddress, state, styles, validation, null, infoTooltip(errorEmailTooltip))}
      </div>
      <Footer
        onBack={onBack}
        backVisible={backVisible}
        backEnabled={backEnabled}
        onCancel={onCancel}
        cancelVisible={cancelVisible}
        cancelEnabled={cancelEnabled}
        onNext={saveConfiguration}
        nextVisible={nextVisible}
        nextEnabled={nextEnabled}
      />
    </>
  );
};

export default Step2;
